const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="card-variations">
  <div class="wrapper-container light">
    <div class="card-one card">
      <div class="card-container">
        <article class="c-card c-card--with-link c-card--horizontal@m">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a href="#" class="c-card__link">Lorem ipsum dolor sit amet</a>
            </h2>
          </header>
          <div class="c-card__cover">
            <img src="https://placeimg.com/800/450/animals" alt="" />
          </div>
          <div class="c-card__content">
            <p>
              Consectetur adipiscing elit. Fusce tempor ut ex nec scelerisque. Quisque
              dui tortor, tempus et tempor in, rhoncus eu massa. Vestibulum dolor erat,
              vestibulum eget velit eu, dignissim hendrerit tortor.
            </p>
          </div>
        </article>
      </div>
      <footer class="c-card__footer t-light footer">
        <p>Jun 4, 2021</p>
      </footer>
    </div>
    <div class="card-two t-dark card">
      <div class="card-container">
        <article class="c-card c-card--with-link c-card--horizontal@m">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a href="#" class="c-card__link">Lorem ipsum dolor sit amet</a>
            </h2>
          </header>
          <div class="c-card__cover">
            <img src="https://placeimg.com/800/450/animals" alt="" />
          </div>
          <div class="c-card__content">
            <p>
              Consectetur adipiscing elit. Fusce tempor ut ex nec scelerisque. Quisque
              dui tortor, tempus et tempor in, rhoncus eu massa. Vestibulum dolor erat,
              vestibulum eget velit eu, dignissim hendrerit tortor.
            </p>
          </div>
        </article>
      </div>
      <footer class="t-dark footer c-card__footer">
        <p>Jun 4, 2021</p>
      </footer>
    </div>
  </div>
  <div class="t-dark wrapper-container">
    <div class="t-dark card-one t-light card">
      <div class="card-container">
        <article class="c-card c-card--with-link c-card--horizontal@m">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a href="#" class="c-card__link">Lorem ipsum dolor sit amet</a>
            </h2>
          </header>
          <div class="c-card__cover">
            <img src="https://placeimg.com/800/450/animals" alt="" />
          </div>
          <div class="c-card__content">
            <p>
              Consectetur adipiscing elit. Fusce tempor ut ex nec scelerisque. Quisque
              dui tortor, tempus et tempor in, rhoncus eu massa. Vestibulum dolor erat,
              vestibulum eget velit eu, dignissim hendrerit tortor.
            </p>
          </div>
        </article>
      </div>
      <footer class="t-dark footer c-card__footer">
        <p>Jun 4, 2021</p>
      </footer>
    </div>
    <div class="card-two t-light card">
      <div class="card-container">
        <article class="c-card c-card--with-link c-card--horizontal@m">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a href="#" class="c-card__link">Lorem ipsum dolor sit amet</a>
            </h2>
          </header>
          <div class="c-card__cover">
            <img src="https://placeimg.com/800/450/animals" alt="" />
          </div>
          <div class="c-card__content">
            <p>
              Consectetur adipiscing elit. Fusce tempor ut ex nec scelerisque. Quisque
              dui tortor, tempus et tempor in, rhoncus eu massa. Vestibulum dolor erat,
              vestibulum eget velit eu, dignissim hendrerit tortor.
            </p>
          </div>
        </article>
      </div>
      <footer class="c-card__footer t-light footer">
        <p>Jun 4, 2021</p>
      </footer>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `fe9442b5e7ac6823820b5688f0cc633cfda344f1cd3ac22b0a47ea8b45533a59`;
            }

            getSourceContext() {
                return new this.Source(``, `fe9442b5e7ac6823820b5688f0cc633cfda344f1cd3ac22b0a47ea8b45533a59`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'fe9442b5e7ac6823820b5688f0cc633cfda344f1cd3ac22b0a47ea8b45533a59');

let template = env.loadTemplate('fe9442b5e7ac6823820b5688f0cc633cfda344f1cd3ac22b0a47ea8b45533a59');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/card-variations/example/example.twig", args: context }
     );
     return rendered;;
};